import React from 'react';
import PropTypes from 'prop-types';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null, errorInfo: null };
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            error,
            errorInfo,
        });
    }

    render() {
        const { errorInfo, error } = this.state;
        const { children } = this.props;
        // This is the only place we allow console logs which are to the error handler
        if (errorInfo) {
            const msg = error.toString();
            console.log(msg, errorInfo.componentStack); // eslint-disable-line no-console
        }
        return children;
    }
}

ErrorBoundary.propTypes = {
    children: PropTypes.node.isRequired,
};

export default ErrorBoundary;
